<template>
    <div class="container-md ">
        <div class="row">
            <div class="col-lg-6 p-3">
                <div>
                    <h3 class="text-uppercase">Rollen</h3>
                </div>
                <div class="container-bg">
                    <table style="height: 350px" class="table table-responsive">
                        <thead>
                            <tr>
                                <th></th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody v-if="rolesLoading">
                            <tr>
                                <td colspan="2">Laden...</td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr v-for="role in roles" :key="role.id">
                                <td>
                                <div class="form-check">
                                    <input
                                    type="checkbox"
                                    class="form-check-input"
                                    :id="'role_' + role.id"
                                    v-model="role.selected"
                                    />
                                </div>
                                </td>
                                <td> {{ role.name }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div v-if="userHasPermissions(['Beheer Rechten', 'Ledenadministratie'])">
                    <button class="btn-dark" v-if="!rolesSaving" @click="saveRoles()">Opslaan</button>
                    <button class="btn-dark" v-else disabled>Opslaan</button>
                </div>
                
            </div>

            <div class="col-lg-6 p-3">
                <div>
                    <h3 class="text-uppercase">Rechten</h3>
                </div>
                <div class="container-bg">
                    <table style="height: 350px" class="table table-responsive">
                        <thead>
                            <tr>
                                <th></th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody v-if="permissionsLoading">
                            <tr>
                                <td colspan="2">Laden...</td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr v-for="permission in permissions" :key="permission.id">
                                <td>
                                <div class="form-check">
                                    <input
                                    type="checkbox"
                                    class="form-check-input"
                                    :id="'permission_' + permission.id"
                                    v-model="permission.selected"
                                    />
                                </div>
                                </td>
                                <td> {{ permission.name }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div v-if="userHasPermissions(['Beheer Rechten', 'Ledenadministratie'])">
                    <button class="btn-dark" v-if="!permissionsSaving" @click="savePermissions()">Opslaan</button>
                    <button class="btn-dark" v-else disabled>Opslaan</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

    export default {
        name: "permissions",
        data(){
            return {
                roles:[],
                permissions:[],
                rolesLoading: true,
                permissionsLoading: true,
                rolesSaving: false,
                permissionsSaving: false,
                currentUserRoles: [],
                currentUserPermissions: []
            }
        },
        methods:{
            saveRoles() {
                this.rolesSaving = true
                this.$store.dispatch('put', {
                    details: this.roles,
                    endpoint: 'api/v1/user-roles/' + this.$route.params.id,
                })
                .then((data)=>{
                    data;
                    this.$store.dispatch('auth/makeNotification',{
                        status: 'Roles',
                        statusText: 'Roles saved successfully'
                    })

                    this.rolesSaving = false
                })
                .catch((error)=>{
                    error;
                    this.rolesSaving = false
                });
            },
            savePermissions() {
                this.permissionsSaving = true
                this.$store.dispatch('put', {
                    details: this.permissions,
                    endpoint: 'api/v1/user-permissions/' + this.$route.params.id,
                })
                .then((data)=>{
                    data;
                    this.$store.dispatch('auth/makeNotification',{
                        status: 'Permissions',
                        statusText: 'Permissions saved successfully'
                    })
                    

                    this.permissionsSaving = false
                })
                .catch((error)=>{
                    error;
                    this.permissionsSaving = false
                });
            }

        },
        computed: {
            ...mapGetters([
            'userRoles',
            'userPermissions',
            ])
        },
        async created(){
            let resp = await this.$store.dispatch('get','api/v1/current-user-roles-permissions/' + this.$route.params.id)
            this.currentUserRoles = resp.data.data.roles
            this.currentUserPermissions = resp.data.data.permissions
            this.$store.dispatch('get','api/v1/roles')
            .then((data)=>{
                this.roles= data.data;
                this.roles.map((role) => {
                    role.selected = this.currentUserRoles.some( r => r.id === role.id )
                    return role;
                })

                this.rolesLoading = false;
            })
            .catch((error)=>{
                error;
                this.rolesLoading = false;
            });

            this.$store.dispatch('get','api/v1/permissions')
            .then((data)=>{
                this.permissions= data.data;
                this.permissions.map((permission) => {
                    permission.selected = this.currentUserPermissions.some( p => p.id === permission.id )
                    return permission;
                })
                this.permissionsLoading = false;
            })
            .catch((error)=>{
                error;
                this.permissionsLoading = false;
            });
        },
    }
</script>
